<template>
    <v-row>
      <v-col cols="12" lg="5" class="text-end">
        <h3 class="font-italic font-weight-light">Ein Gefühl,<br/>
          das kaum zu beschreiben<br/>
          und durch nichts anderes<br/>
          zu ersetzen ist...
        </h3>
      </v-col>
      <v-col cols="12" lg="5">
        <h4>Theatergruppe Heidekraut e.V.</h4><br/>
        <p class="body-1"><strong>Wer sind wir?</strong></p>
        <p class="body-1">Wir sind begeistert vom Theater und jedes Lächeln im Publikum treibt uns an.</p>
        <br/>
        <p class="body-1"><strong>Was machen wir?</strong></p>
        <p class="body-1">Neben aktuellen Produktionen verschiedenster Theaterstücke machen wir:</p>
        <ul style="list-style-type:square;">
            <li><p class="body-1">Schauspieltraining</p></li>
            <li><p class="body-1">Sprechtraining</p></li>
            <li><p class="body-1">uvm...</p></li>
        </ul>
        <br/>
        <strong>Nimm doch <router-link to="/Kontakt">KONTAKT</router-link> mit uns auf!</strong>
          <br>
          <br>
          <br>
          <h4>Mitglied werden</h4>
          <p class="body-1 pt-5">
              Wenn Du Dich für' s Mitspielen oder Mitmachen entscheidest, solltest Du Mitglied bei uns werden.<br><br>
              Unsere Mitgliedsbeiträge:

          </p>
          <table style="border-spacing: 1em">
              <tr>
                  <td><b>Normal</b></td>
                  <td>80 Euro pro Quartal</td>
              </tr>
              <tr>
                  <td><b>München-Pass</b></td>
                  <td>10 Euro pro Quartal</td>
              </tr>
              <tr>
                  <td><b>Erm&auml;ßigt</b></td>
                  <td>50 Euro pro Quartal</td>
              </tr>
              <tr>
                  <td><b>Passiv</b></td>
                  <td>10 Euro pro Quartal</td>
              </tr>
          </table>

          <br/>
          Warum der Mitgliedsbeitrag? Damit bezahlen wir unsere professionellen und engagierten Regisseur*innen,
          sowie Kosten für Proberäume und Versicherungen.
          Zu viel für Dich? Bitte scheu Dich trotzdem nicht uns zu schreiben, wir finden für alles eine Lösung!
          <br/><br/>
          Wir freuen uns auf Dich!
          <br/><br/>

      </v-col>
    </v-row>
</template>

<script>

    export default {
        name: "Verein",
        metaInfo: {
            title: "Verein",
            meta: [
                {name: 'description', content: 'Details zu unserem Verein'}
            ]
        },
    }
</script>

<style scoped>

</style>